import {AnnouncementAudienceEnum} from "@/models/enum/AnnouncementAudienceEnum";
import {AnnouncementModel} from "@/models/announcement/AnnouncementModel";

/**
 * Announcements shown to the user in a modal after login.
 *
 * Add a new entry to communicate a change in the application, together with its
 * translations under the 'announcements.<code>' key in the message files. Only the
 * first announcement that is active and not yet dismissed is shown; the others
 * follow on a next visit.
 *
 * See README.md ("Announcements") for the full procedure.
 */
export const ANNOUNCEMENTS: AnnouncementModel[] = [
    {
        code: 'sidebarNavigation',
        audience: AnnouncementAudienceEnum.AUTHENTICATED,
        endDate: '2026-09-30',
    },
];
